export default {
    /**
     * 在第二级子路由页面使用，当路由切换到其子路由的时候，隐藏当前组件
     * @param {Object} context this
     * @param {String/Array} routeName 可渲染的路由名称
     */
    renderWhen(context, routeName) {
        const router = context.$route;
        if (Array.isArray(routeName)) {
            return routeName.some(name => name === router.name);
        } else {
            return router.name === routeName;
        }
    },

    /**
     * 对象的深度拷贝
     * @param data 需要拷贝的元数据
     * @return {any} 返回拷贝后的新数据
     */
    deepClone(data) {
        const type = this.getType(data);
        let obj;
        if (type === 'array') {
            obj = [];
        } else if (type === 'object') {
            obj = {};
        } else {
            //不再具有下一层次
            return data;
        }
        if (type === 'array') {
            for (let i = 0, len = data.length; i < len; i++) {
                obj.push(this.deepClone(data[i]));
            }
        } else if (type === 'object') {
            for (let key in data) {
                obj[key] = this.deepClone(data[key]);
            }
        }
        return obj;
    },

    /**
     * 判断对象类型
     * @param {Object} object
     * @return {String} object type
     */
    getType(object) {
        var toString = Object.prototype.toString;
        var map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object'
        };
        if (object instanceof Element) {
            return 'element';
        }
        return map[toString.call(object)];
    },

    /**
    *
    * @param {Function} fn target function
    * ` Must contains two parameters
    */
    promisefy(fn) {
        function awaitable(...args) {
            return new Promise(function (resolve, reject) {
                const callback = function (err, data) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                };
                args.push(callback);
                fn.apply(null, args);
            });
        }

        return awaitable;
    },
    //通过地址编码获取地址名
    findAddrByCode(codeArr){
        let curSearchObj = this.areaObj
        let result = []
        for (let i = 0; i < codeArr.length; i++) {
            for (var j = 0; j < curSearchObj.length; j++) {
                if (curSearchObj[j]['value'] === codeArr[i]) {
                    result.push(curSearchObj[j]['label'])
                    curSearchObj = curSearchObj[j]['children']
                    break
                }
            }
        }
        return result
    },
    toReduce(num, d) {
        if (!num) return "0.00";
        var s=num+"";
        if (!d) d = 0;
        if (s.indexOf(".") == -1) s += ".";
        s += new Array(d + 1).join("0");
        if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
            var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
            if(a==d+2){
                a=s.match(/\d/g);
                s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");
            }if(b)s=s.substr(1);
            return (pm+s).replace(/\.$/,"");
        } return this + "";

    },
    toFixed(num, d) {
        if (!num) return "0.00"
        var s=num+"";
        if(!d)d=0;
        if(s.indexOf(".")==-1)s+=".";
        s+=new Array(d+1).join("0");
        if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
            var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
            if(a==d+2){
                a=s.match(/\d/g);
                if(parseInt(a[a.length-1])>4){
                    for(var i=a.length-2;i>=0;i--){
                        a[i]=parseInt(a[i])+1;
                        if(a[i]==10){
                            a[i]=0;
                            b=i!=1;
                        }else break;
                    }
                }
                s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");
            }if(b)s=s.substr(1);
            return (pm+s).replace(/\.$/,"");
        }return this+"";
    },

    thousandSplit(str) {
        if (str == 0) {
            return 0;
        }
        if (!str) {
            return undefined;
        }
        var reg = new RegExp(/(?=(?!\b)(\d{3})+$)/g);
        var strs = str + "";
        return strs.replace(reg, ',');
    },

    /**
     * 购买途径
     */
    orderPlatform: ['', '线下门店', '官方app', '微信小程序', '第三方购买', '管理后台', '其他', '点餐小程序', '吧台', '阿派朗点餐小程序', '购买活动商品赠送', '兑换'],

    platform: ['', '收银台', '', '微信小程序', '管理后台', '第三方购买', '积分小程序', '积分后台'],
    /**
     * 支付方式
     */
    payMode: ['无需支付', '支付宝', '微信', 'POS机', '现金', "-", '储值', 'WPOS', '积分兑换', '支付宝-线下', '微信-线下','扫码枪','银联小程序'],

    payState: ["", "待支付", "已支付", "支付失败", "退款中", "部分退款", "全部退款", "已关闭"],

    refundState: ["", "退款中", "退款成功", "退款失败"],

    transState: ["", "未完成", "已完成", "已关闭"],

    uselessState: ["-", "退款", "升级", "持有人更改", "赠送他人"],

    goodsType: {
        TICKET: "票券",
        RETAIL: "零售",
        BALANCE: "储值",
        ACTIVITY: "活动",
    },

    category: {
        Buy: "票券购买",
        Upgrade: "升级",
        Frozen: "冻结",
        ValidityReset: "有效期重置",
        ExchangeCard: "票券-补换卡",
        ChangeCard: "会员-补换卡",
        Exchange: "兑换",
        GoodsGrant: "补开卡",
        Delay: "过期续期"
    },

    ticketState: {
        VALID: "已生效",
        USED: "次数用完",
        OVERDUE: "已过期",
        INVALID: "已失效",
        LOCK: "已锁定"
    },

    auditState: {
        '0': "审批中", '1': "审批通过", "2": "无需审批", "-1": "审批不通过", "-2": "已撤回"
    },
    EsTradeStateOptions: [
        {
            label: '待支付',
            value: 1
        },
        {
            label: '已支付',
            value: 2
        },
        {
            label: '支付失败',
            value: 3
        },
        {
            label: '退款中',
            value: 4
        },
        {
            label: '部分退款',
            value: 5
        },
        {
            label: '全部退款',
            value: 6
        },
        {
            label: '已关闭',
            value: 7
        }
    ],

    toDouble(num) {
        return Number(num) < 10 ? '0' + Number(num) : Number(num)
    },
    weekDays(time) {
        if (!time) {
            return ''
        }
        var date = new Date(time);
        var week = ["日", "一", "二", "三", "四", "五", "六"];
        return week[date.getDay()]
    },
}

// js获取当前日期，并且转化为时间格式“yyyy-MM-dd HH:MM:SS”
function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "/";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        + " " + date.getHours() + seperator2 + date.getMinutes()
        + seperator2 + date.getSeconds();
    return currentdate;
}

